module.exports = __webpack_public_path__ + "static/media/selectStoreCheckOut.fc88d6d2.png";